// extracted by mini-css-extract-plugin
export default {"bubbleThink":"BubbleThink__bubbleThink___y0pW0","bubbleThinkHeader":"BubbleThink__bubbleThinkHeader___f9u5L","bubbleThinkContent":"BubbleThink__bubbleThinkContent___muQkQ"};